export default "__VITE_ASSET__w_nK5iTY__"